module.exports = __webpack_public_path__ + "img/sportlander.c148a60a.png";